export default {
  notificationGroupList: [],
  notificationGroupInfo: {
    name: '',
    type: '',
    member_ids: ''
  }
}
